import { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { customStyles2 } from "../../util/TableStyles";
import { noDataComponent } from "../../util/DataObject";
import { paginationComponentOptions } from "../../util/i18n-es";
import { FlexGrid, Typography, useThemeProvider, Card } from "@albo-ui/core";
import { TaskAlt } from "@mui/icons-material";
import moment from "moment";
import "moment/locale/es";

const ValidationResults = (props) => {
    moment.locale("es");
    const { theme } = useThemeProvider();
    const [validationList, setValidationList] = useState([]);

    const validate = (info) => {
        switch (info) {
            case "POSITIVE":
            case "validated":
                return <label className={`validate`}>Correcto</label>;
            case "NEGATIVE":
                return <label className={`invalidate`}>Incorrecto</label>;
            case "INDETERMINATED":
                return "Indeterminado"
            default:
                return info;
        }
    };
    const columns = [
        { selector: (row) => row.text, name: "Validación", width: "34%", sortable: false },
        { selector: (row) => (row.data ? validate(row.data) : "N/A"), name: "Estatus", width: "26%", sortable: false },
        { selector: (row) => row.date ? moment(row.date).format("LLL") : "N/A", name: "Fecha validación",  sortable: false },
    ];

    useEffect(() => {
        setValidationList(props.content.reverse());
    }, [props.content]);

    return (
        <div className="size-6 dataBlock">
            <Card
                padding={2} fullWidth flexDirection="column" alignItems="stretch" justifyContent="space-between"
                style={{ borderColor: theme.colors.manatee, height: "auto" }}
            >
                <FlexGrid container item direction="column" spacing={1}>
                    <FlexGrid item style={{ paddingBottom: "0.8rem" }}>
                        <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem" }}>
                            <TaskAlt sx={{ mr: 1 }} /> Validaciones
                        </Typography>
                    </FlexGrid>

                    <FlexGrid container spacing={2}>
                        <DataTable
                            columns={columns}
                            data={validationList}
                            customStyles={customStyles2}
                            noDataComponent={noDataComponent}
                            paginationComponentOptions={paginationComponentOptions}
                            dense
                        />
                    </FlexGrid>
                </FlexGrid>
            </Card>
        </div>
    );
};

export default ValidationResults;
